import React from 'react'
import textToIcon from '../helpers/textToIcon.js'

class Table extends React.Component {
  constructor(props) {
    super(props)
  }

  fields(fields, index) {
    const accessLevel = this.props.accessLevel
    return fields.map((field, index) => {
      const value = accessLevel === 'bronze' && index > 0 ? '' : field.value
      const markup = textToIcon(field, value, 'table')
      return (
          field.key === 'peoples-choice' ? null :
          <div className="service-data-element w-100 fl pv2 ph3" data-field-key={field.key} key={field.id}>
           {markup}
          </div>
        )
    })
  }

  freeAccessTable() {
    return(<div className="z-1 w4-half ba pt2 ma2 mr0-ns ma2-ns mb0-ns b--light-silver br2 services-tile-animation flex flex-column flex-shrink-0 flex-grow-0 table-element h-100 relative cta-table-container"
                    dangerouslySetInnerHTML={{__html: this.props.directoryFreeExplanationPartialTable}}></div>)
  }

  displayPeoplesChoice() {
    let recomms = this.props.values && this.props.values.recommendations;

    if (recomms && recomms.peoples_choice && this.props.accessLevel !== 'bronze') {
      return (
        <div className="tile-image-container relative mta mla mra">
          <a href="/articles/peoples-choice">
            <span
              className="badge-sprite badge-sprite--peoples-choice--with-text--small"
              aria-label="People's Choice."
            ></span>
          </a>
        </div>
      )
    } else {
      return null;
    }
  }

  displayPriceValue(values, price) {
    if(this.props.accessLevel == 'bronze') {
      return <div className="block-get-access-copy relative flex flex-column mta mb4 mla mra db">
        <div className="lock"></div>
        <a className="underline small tc a--black" href="/purchase/join">Unlock premium</a>
      </div>
    } else {
      return <div className="ph2 ph0-ns pb3 db w-100 mta">
        <h3 className="h4 tc mb0 numeric-font b">{price}</h3>
        <h3 className="h5 b tc fw4 mt2">{price.startsWith('$') ? this.props.service_payment_period_label : '\u00A0'}</h3>
      </div>
    }
  }

  render() {
    if(this.props.isDonateCTA) {
      return this.freeAccessTable()
    }

    const values = this.props.values
    if(typeof values.calculations === 'undefined')
      values.calculations = []
    const priceWrapper = values.calculations.find((c) => Object.keys(c)[0] == this.props.filterKey)
    let price

    if(typeof priceWrapper !== 'undefined') {
      price = priceWrapper[this.props.filterKey]
      if (typeof price == 'undefined') {
        price = 'n/a';
      }
      if (!price.toString().replace(/\s/g, '').length) {
        price = 'n/a';
      }
      if (!isNaN(parseInt(price))) {
        price = `$${parseFloat(price).toFixed(2)}`
      }
    } else {
      price = 'n/a'
    }

    return (
      <article className="w4-half ba pt2 ma2 mr0-ns ma2-ns mb3-ns b--light-silver br2 tile-background services-tile-animation flex flex-column flex-shrink-0 flex-grow-0 table-element">
        <a className={`${this.props.accessLevel == 'bronze' ? 'pointer-disabled o-50' : ''} db link small tr pb2 remove mr2 outline-0`} href="#" value={values.id} onClick={this.props.handleRemoveItem}></a>
        <div className={`w-100 flex flex-column image-container ${this.props.accessLevel === 'bronze' ? 'bronze' : ''}`}>
          <img className="w-90 mla mra pb3 h-auto mt1" src={`${values.image}`} alt={values.brand + " logo"} />
          <div className="ph2 ph3">
            <h3 className="h5 b tc mb0">{values.brand}</h3>
            <h3 className="tc small fw5 mt2 lh-title mb0">{values.title}</h3>
          </div>
          {this.displayPeoplesChoice()}
          {this.displayPriceValue(values, price)}
        </div>
        <div className="ph2">
          <a className="Button Button--blue Button--wide"
            href={values.url}>View details</a>
        </div>
        <div className="w-100 mt3-half">
          {this.fields(this.props.values.fields.slice(0, this.props.tableFieldCount))}
        </div>
      </article>
    )
  }
}

export default Table
